module.exports = __webpack_public_path__ + "static/media/u21a-c_f1.a02d27ba.mp3";